"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortReportItems = exports.sortReportCategoryItems = exports.sortItemsByPropertyInArray = exports.sortItemsByProperty = exports.sortGroupedRecordsBySkuProperty = exports.removeGroupBulkRecords = exports.prepareReportCategoryItems = exports.groupRecordsBySkuId = exports.groupRecordsByRecordsetIdAndSkuId = exports.getTotalAmount = exports.appendParentCategoryItems = exports.DEFAULT_DECIMAL_PRECISION = void 0;

var _lodash = require("lodash");

var _commons = require("@stktk/commons");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var DEFAULT_DECIMAL_PRECISION = 2;
exports.DEFAULT_DECIMAL_PRECISION = DEFAULT_DECIMAL_PRECISION;

var groupRecordsBySkuId = function groupRecordsBySkuId(records) {
  var sortedRecords = sortItemsByPropertyInArray(records, 'name');
  return Object.values((0, _lodash.groupBy)(sortedRecords, function (item) {
    return item.sku.id;
  }));
};

exports.groupRecordsBySkuId = groupRecordsBySkuId;

var groupRecordsByRecordsetIdAndSkuId = function groupRecordsByRecordsetIdAndSkuId(records) {
  var sortedRecords = sortItemsByPropertyInArray(records, 'name');
  return Object.values((0, _lodash.groupBy)(sortedRecords, function (item) {
    return "rid".concat(item.recordsetId, "sid").concat(item.sku.id);
  }));
};

exports.groupRecordsByRecordsetIdAndSkuId = groupRecordsByRecordsetIdAndSkuId;

var removeGroupBulkRecords = function removeGroupBulkRecords(records, action, restaurantId) {
  var uniqueRecordsetIds = _toConsumableArray(new Set(records.map(function (record) {
    return record.recordsetId;
  })));

  var _records = _slicedToArray(records, 1),
      skuId = _records[0].skuId;

  return action(uniqueRecordsetIds.map(function (recordsetId) {
    return {
      restaurantId: restaurantId,
      recordsetId: recordsetId,
      skuId: skuId
    };
  }));
};

exports.removeGroupBulkRecords = removeGroupBulkRecords;

var getTotalAmount = function getTotalAmount(items) {
  var totalValue = 0;
  items.forEach(function (item) {
    totalValue += (0, _commons.getTotalRecordSkuNormalizedAmount)(item, item.sku);
  });
  return totalValue.toFixed(DEFAULT_DECIMAL_PRECISION);
};

exports.getTotalAmount = getTotalAmount;

var sortGroupedRecordsBySkuProperty = function sortGroupedRecordsBySkuProperty(items, property, order) {
  return (0, _lodash.orderBy)(items, "[0].sku.".concat(property), order);
};

exports.sortGroupedRecordsBySkuProperty = sortGroupedRecordsBySkuProperty;

var sortItemsByProperty = function sortItemsByProperty(items, property, order) {
  return property ? (0, _lodash.orderBy)(items, property, order) : items;
};

exports.sortItemsByProperty = sortItemsByProperty;

var sortItemsByPropertyInArray = function sortItemsByPropertyInArray(items, property) {
  return items.sort(function (a, b) {
    return a.sku[property].localeCompare(b.sku[property]);
  });
};

exports.sortItemsByPropertyInArray = sortItemsByPropertyInArray;

var sortReportItems = function sortReportItems(items) {
  items.sort(function (a, b) {
    return a[0].localeCompare(b[0]);
  });
};

exports.sortReportItems = sortReportItems;

var sortReportCategoryItems = function sortReportCategoryItems(items) {
  return (0, _lodash.orderBy)(items, 'parentId');
};

exports.sortReportCategoryItems = sortReportCategoryItems;

var prepareReportCategoryItems = function prepareReportCategoryItems(items) {
  var showParents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var sortedItems = sortReportCategoryItems(items);
  return showParents ? appendParentCategoryItems(sortedItems) : sortedItems;
};

exports.prepareReportCategoryItems = prepareReportCategoryItems;

var appendParentCategoryItems = function appendParentCategoryItems(items) {
  return (0, _lodash.flatten)((0, _lodash.map)((0, _lodash.groupBy)(items, 'parentId'), function (group) {
    return [_objectSpread(_objectSpread({}, group[0].parent), {}, {
      data: (0, _lodash.flatten)((0, _lodash.map)(group, 'data'))
    })].concat(_toConsumableArray(group));
  })).map(function (item, index) {
    return _objectSpread(_objectSpread({}, item), {}, {
      sort: index
    });
  });
};

exports.appendParentCategoryItems = appendParentCategoryItems;